<script setup lang="ts">
  interface Props {
    classProps?: string
  }

  const props = withDefaults(defineProps<Props>(), {
    classProps: '',
  })
</script>
<template>
  <button
    class="bg-primary-standard active:brightness-75 py-3 w-full rounded-full text-white font-semibold flex-1 shadow-default font-dmsans"
    :class="props.classProps"
  >
    <slot></slot>
  </button>
</template>
